<a class="card-movie" (click)="goMovie($event, movie.id)" (mouseenter)="hoverItem = true"
    (mouseleave)="hoverItem = false" href={{movieLink}} [class.useHover]="useHover">
    <div class="tarjeta">

        <!-- Cocarda Free-->
        <div class="tarjeta__cocarda" *ngIf="isFree">
            <div class="tarjeta__cocarda-line">
                GRATIS
            </div>
        </div>
        <!-- Cocarda Estreno-->
        <div class="tarjeta__cocarda" *ngIf="esEstreno">
            <div class="tarjeta__cocarda-line line-estreno">
                ESTRENO
            </div>
        </div>
        <!-- Cocarda Sala-->
        <div class="tarjeta__cocarda" *ngIf="esCinema">
            <div class="tarjeta__cocarda-line line-salas">
                EN SALAS
            </div>
        </div>

        <img class="imagen" (click)="goMovie($event, movie.id)" src="{{fotoPrincipal | ThumbnailImage}}" alt="">

        <!-- Opciones viejas -->
        <!-- <div class="opciones">
            <div class="fondo"></div>
            <div class="dropdown dropleft">
                <button class="btn bg-none text-white" type="button" id="dropdownMenuButton" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    <i class="fas fa-ellipsis-v"></i>
                </button>

                <div class="dropdown-menu " aria-labelledby="dropdownMenuButton">
                    <a class="dropdown-item px-3" (click)="goMovie($event, movie.id, true)">
                        <i class="fas fa-external-link-alt mr-2"></i>
                        Abrir en nueva pestaña
                    </a>
                </div>
            </div>
        </div> -->

        <div class="informacion p-3">
            <h2 class="titulo">{{ movie.title }}</h2>
            <h3 class="director">{{ nombreCompletoDirector }}</h3>
        </div>

        <div class="hover" *ngIf="useHover">
            <div class="seccion">
                <div class="sinopsis flex-grow-1">
                    <p class="elipsis-4 " [innerHTML]="movie.synopsis"> </p>
                </div>

                <div class="">
                    <span class=" anio">{{ movie.releaseYear }}</span>
                    <span class="duracion">{{ movie.length }} min</span>
                </div>
            </div>
        </div>

    </div>
</a>